import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import { useAction, useAppSelector } from 'shared/hooks/redux/hooks';
import { FirmwareFooter } from './firmware-footer';
import { fetch_upload_action, file_upload_action, prefix_action, remove_file_action, } from '../redux/action';
import { Box, IconButton, List, ListItem, ListItemIcon, ListItemSecondaryAction, ListItemText, } from '@mui/material';
import { Close, Info } from '@mui/icons-material';
import { InputWithDrop } from 'console/device-settings/z3k/components/material-utils/input-with-drop';
import { ControlWithoutValidation } from 'console/shared/components/fields/control/without-validation';
import { TextInputWrapper } from 'console/shared/components/fields/text';
function UploadComponent() {
    const { upload } = useAppSelector((state) => state.upgrade_soft);
    const onFilesChange = useAction(file_upload_action);
    const update = useAction(fetch_upload_action);
    const onChangePrefix = useAction(prefix_action);
    const handleFileRemove = useAction(remove_file_action);
    return (_jsxs(Box, { display: "flex", flexDirection: "column", height: "90%", gap: 2, children: [_jsx(InputWithDrop, { height: "20%", onFileSelect: onFilesChange }), _jsx(ControlWithoutValidation, { label: "\u041F\u0440\u0435\u0444\u0438\u043A\u0441", value: upload.prefix, onChange: onChangePrefix, field: TextInputWrapper }), _jsx(List, { children: upload.files.length > 0 ? (upload.files.map((file) => (_jsxs(ListItem, { children: [_jsx(ListItemText, { primary: file.name }), _jsx(ListItemSecondaryAction, { children: _jsx(IconButton, { onClick: () => handleFileRemove(file.name), children: _jsx(Close, {}) }) })] }, file.name)))) : (_jsxs(ListItem, { children: [_jsx(ListItemIcon, { children: _jsx(Info, {}) }), _jsx(ListItemText, { primary: "\u041D\u0435\u0442 \u0444\u0430\u0439\u043B\u043E\u0432 \u043A \u0437\u0430\u0433\u0440\u0443\u0437\u043A\u0435" })] })) }), _jsx(FirmwareFooter, { is_loading: upload.is_loading, title: "\u0417\u0430\u0433\u0440\u0443\u0437\u0438\u0442\u044C \u0444\u0430\u0439\u043B\u044B", onUpdateClick: update })] }));
}
export const UploadFirmware = {
    key: 'Upload',
    title: 'Загрузка файлов',
    element: UploadComponent,
    validate() {
        return null;
    },
    data2state() {
        return null;
    },
    state2data() {
        return null;
    },
};
